import { countries, type TCountryCode } from 'countries-list';
import { getCountries } from 'libphonenumber-js/max';

export type CountryOption = {
  code: TCountryCode;
  name: string;
  dialCode: string;
  emoji: string;
};

const SUPPORTED = new Set<string>(getCountries());

// countries-list dropped the `emoji` field on ICountry; derive it from the
// alpha-2 code via regional indicator symbols.
function codeToEmoji(code: string): string {
  return code
    .toUpperCase()
    .split('')
    .map((c) => String.fromCodePoint(0x1f1e6 + c.charCodeAt(0) - 65))
    .join('');
}

export const COUNTRY_OPTIONS: CountryOption[] = Object.entries(countries)
  .filter(([code]) => SUPPORTED.has(code))
  .map(([code, c]) => ({
    code: code as TCountryCode,
    name: c.name,
    dialCode: String(Array.isArray(c.phone) ? c.phone[0] : c.phone),
    emoji: codeToEmoji(code),
  }))
  .sort((a, b) => a.name.localeCompare(b.name));
